import React from "react";
import { Button } from "react-bootstrap";
import { UiBannerBottomBar } from "../../components/common/UiBannerBottomBar";
import UiInnerBanner from "../../components/common/UiInnerBanner";
import UiMainWrapper from "../../components/common/UiMainWrapper";
import { UiContentWr } from "../../components/common/UiPageElements";
import { UiTable } from "../../components/common/UiTable";
import Footer from "../../components/footer/Footer";
import { UiCol, UiRowContainer, UiSingleRow } from "../../components/grid-container/GridContainer";
import TopHeader from "../../components/header/TopHeader";
import { AddTeamMembership } from "./views/AddTeamMembership";
import { GoalsFaq } from "./views/GoalsFaq";
import { GoalsProgressBar } from "./views/GoalsProgressBar";
import { HistoricGoals } from "./views/HistoricGoals";
import { KeyInformation } from "./views/KeyInformation";
import { TeamMemberOverviewTable } from "./views/TeamMemberOverviewTable";
import { YourOtherGoals } from "./views/YourOtherGoal";

export const GoalMet = () => {

    return (
        <>
            <UiMainWrapper>
                <TopHeader />
                <UiInnerBanner
                    title="Nick’s Weekend Away"
                    description="Goal In Progress"
                />

                <UiBannerBottomBar
                    prevPage="Shop"
                    prevPageLink="/ui"
                    currentPage="Goals < Nick’s Weekend Away"
                    currentPageLink="/ui" />

                <GoalsProgressBar
                    title="Nick’s Weekend Away"
                    progress="100"
                    totalPoints="3,000"
                    gainedPoints="3,000"
                />

                <KeyInformation />

                <AddTeamMembership />

                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="5">
                            <GoalsFaq />
                        </UiCol>
                        <UiCol lg="7">
                            <TeamMemberOverviewTable />
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>

                <YourOtherGoals />

                <HistoricGoals />

                <Footer />

            </UiMainWrapper>
        </>
    )
}